export default {
    def: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`,
    bgs: [
        {name: 'bg1', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg1.jpg`},
        {name: 'bg2', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg2.jpg`},
        {name: 'bg3', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg3.jpg`},
        {name: 'bg4', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg4.jpg`},
        {name: 'bg5', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg5.jpg`},
        {name: 'bg6', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg6.jpg`},
        {name: 'bg7', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg7.jpg`},
        {name: 'bg8', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg8.jpg`},
        {name: 'bg9', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg9.jpg`},
        {name: 'bg10', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg10.jpg`},
        {name: 'bg12', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-BGbg11.jpg`},
        {name: 'bg11', img: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`}
    ],
    overlays: {
        dropbox: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-dropbox.png`,
        trello: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-trello.png`,
        googlespreadsheets: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-googlesheets.png`,
        googledocs: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-googledocs.png`,
        pdf: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-pdf.png`,
        gmail: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-gmail.png`,
        youtube: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-youtube.png`,
        spotify: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-spotify.png`,
        pintrest: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-pintrest.png`,
        whatsapp: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-whatsapp.png`,
        linkedin: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-linkedin.png`,
        twitter: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-twitter.png`,
        instagram: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-instagram.png`,
        tumblr: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-tumblr.png`,
        facebook: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-facebook.png`,
        dribble: `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-dribble.png`,
    }
}